import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, ShieldCheck, CheckCircle, Key } from 'lucide-react';
import { Button } from '../ui/button';
import { TesterCodeModal } from './TesterCodeModal';

export function LockedModuleOverlay() {
  const navigate = useNavigate();
  const [showTesterModal, setShowTesterModal] = useState(false);

  return (
    <>
      <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-3xl max-w-md w-full p-8 text-center shadow-2xl fade-in">
          <div className="w-16 h-16 bg-primary/10 rounded-full mx-auto mb-6 flex items-center justify-center">
            <Lock className="w-8 h-8 text-primary" />
          </div>
          
          <h2 className="font-heading font-bold text-2xl text-text mb-3">
            This Module is Locked
          </h2>
          
          <p className="text-text-muted mb-6">
            Purchase the full course to unlock all 12 modules, quizzes, and your completion certificate.
          </p>

          <div className="bg-stone-50 rounded-xl p-4 mb-6 text-left">
            <p className="font-semibold text-text mb-3">Full course includes:</p>
            <ul className="space-y-2 text-sm">
              {[
                'All 12 comprehensive modules',
                'Interactive quizzes & checklists',
                'Completion certificate',
                'Lifetime access',
              ].map((item, index) => (
                <li key={index} className="flex items-center gap-2 text-text-muted">
                  <CheckCircle className="w-4 h-4 text-success flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-3">
            <Button
              onClick={() => navigate('/purchase')}
              data-testid="unlock-course-button"
              className="w-full bg-primary text-white hover:bg-primary-600 rounded-xl py-5 text-lg font-bold"
            >
              <ShieldCheck className="w-5 h-5 mr-2" />
              Unlock for $6.99 AUD
            </Button>
            
            <Button
              onClick={() => navigate('/')}
              variant="outline"
              className="w-full rounded-xl py-4"
            >
              Back to Home
            </Button>
          </div>

          {/* Tester code link */}
          <div className="mt-6 pt-4 border-t border-stone-200">
            <button
              onClick={() => setShowTesterModal(true)}
              data-testid="have-tester-code"
              className="text-sm text-text-muted hover:text-primary transition-colors flex items-center justify-center gap-2 w-full"
            >
              <Key className="w-4 h-4" />
              Have a tester code?
            </button>
          </div>

          <p className="text-text-muted text-xs mt-4">
            Module 1 (Introduction) is free to try!
          </p>
        </div>
      </div>

      {/* Tester Code Modal */}
      <TesterCodeModal 
        isOpen={showTesterModal} 
        onClose={() => setShowTesterModal(false)} 
      />
    </>
  );
}
